import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { redirectTarget } from './productNavigation';
export default function RouteAlias({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate replace state={location.state} to={redirectTarget(to, location.search, location.hash)} />;
}
